import { faFileLines } from '@fortawesome/pro-solid-svg-icons';

import { FileModel } from 'models';

import { Icon } from 'core/ui';

import { ImgProxy } from 'features/file/fragments/ImgProxy';

// Helper component moved from PatientFiles.tsx / GalleryView / ListView
// It needs access to FileModel type.

export const FileThumbnailDisplay = ({ file, viewType = 'list' }: { file: FileModel | null; viewType?: 'list' | 'gallery' }) => {
  if (!file) {
    return <Icon icon={faFileLines} className="placeholder-icon" />;
  }

  const commonProps = {
    fileId: file.id,
    thumbnailUrl: file.thumbnailUrl ?? file.thumbnailLocation ?? '',
    dateModified: file.modified,
    isReadOnly: true,
  };

  const placeholderIcon = faFileLines; // Or getFileIcon if that helper is extracted too

  if (viewType === 'gallery') {
    // Gallery view with size hints for better performance
    return file.thumbnailUrl || file.thumbnailLocation ? (
      <ImgProxy {...commonProps} height="200" width="200" />
    ) : (
      <Icon icon={placeholderIcon} className="placeholder-icon" />
    );
  } else {
    // List view with size hints
    return file.thumbnailUrl || file.thumbnailLocation ? (
      <ImgProxy {...commonProps} height={180} width="240" />
    ) : (
      <Icon icon={placeholderIcon} className="placeholder-icon" />
    );
  }
};
